import { useEtiquetas } from '../lib/etiquetas-context';

interface Props {
  nome: string;
  cor?: string;
  apelido?: string | null;
}

/**
 * Cor de texto legivel sobre a cor da etiqueta. **Exportada** porque o seletor de etiquetas da
 * aba Contatos do Dia ([DA-694]) pinta o chip marcado com a MESMA cor do selo — reescrever a
 * conta la faria o chip divergir do selo que ele representa, na mesma linha da tela.
 */
export function corDoTexto(bgHex: string): string {
  if (!bgHex || !bgHex.startsWith('#')) return '#334155';
  const hex = bgHex.slice(1);
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  if (lum > 0.6) {
    return `#${Math.round(r * 0.3).toString(16).padStart(2, '0')}${Math.round(g * 0.3).toString(16).padStart(2, '0')}${Math.round(b * 0.3).toString(16).padStart(2, '0')}`;
  }
  return '#ffffff';
}

// ⛔ NAO gerar apelido a partir do nome (corte do Ruan, 03/09/2026). Ate aqui a pill
// derivava `TRANS` de `transportes` quando o campo era nulo, e a edicao abria VAZIA —
// a tela mostrava um valor que nao existia em lugar nenhum. Os 8 nulos foram gravados
// com o que a pill ja exibia, e o modal passou a exigir o campo. Sem apelido, o nome
// e' o que aparece: apelido inventado e' pior que nome comprido.
export function BadgeEtiqueta({ nome, cor, apelido }: Props) {
  const { porNome } = useEtiquetas();
  const cache = porNome.get(nome);
  const corFinal = cor ?? cache?.cor ?? '#e2e8f0';
  const apelidoFinal = apelido ?? cache?.apelido ?? nome;
  return (
    <span
      className="inline-block px-1.5 py-0.5 rounded text-[10px] font-bold leading-none"
      style={{ backgroundColor: corFinal, color: corDoTexto(corFinal) }}
    >
      {apelidoFinal}
    </span>
  );
}
